import { createSlice } from '@reduxjs/toolkit';
import { Route } from '@react-navigation/native';
import {
	pushBottomSheetAction,
	popBottomSheetAction,
	clearBottomSheetStackAction,
	setCloseTargetIdAction,
	setPreCloseActionAction,
	setSkipNavigationOnCloseAction,
} from './actions';

export type BottomSheetRoute = Route<string, object | undefined> | null;

export interface BottomSheetContext {
	id: string;
	returnRoute: BottomSheetRoute;
}

export interface BottomSheetState {
	stack: BottomSheetContext[];
	closeTargetId: string | null;
	preCloseAction: (() => void) | null;
	skipNavigationOnClose: boolean;
}

const initialState: BottomSheetState = {
	stack: [],
	closeTargetId: null,
	preCloseAction: null,
	skipNavigationOnClose: false,
};

const bottomSheetSlice = createSlice({
	name: 'bottomSheet',
	initialState,
	reducers: {
		pushBottomSheet: pushBottomSheetAction,
		popBottomSheet: popBottomSheetAction,
		clearBottomSheetStack: clearBottomSheetStackAction,
		setCloseTargetId: setCloseTargetIdAction,
		setPreCloseAction: setPreCloseActionAction,
		setSkipNavigationOnClose: setSkipNavigationOnCloseAction,
	},
});

// Export actions
export const {
	pushBottomSheet,
	popBottomSheet,
	clearBottomSheetStack,
	setCloseTargetId,
	setPreCloseAction,
	setSkipNavigationOnClose,
} = bottomSheetSlice.actions;

// Selectors
export const selectBottomSheetStack = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.stack;
export const selectTopBottomSheet = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.stack[state.bottomSheet.stack.length - 1] ?? null;
export const selectCloseTargetId = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.closeTargetId;
export const selectPreCloseAction = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.preCloseAction;
export const selectSkipNavigationOnClose = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.skipNavigationOnClose;
// Backward-compatible selector - returns the return route of the top sheet (previously nonBottomSheetScreen)
export const selectNonBottomSheetScreen = (state: { bottomSheet: BottomSheetState }) => state.bottomSheet.stack[state.bottomSheet.stack.length - 1]?.returnRoute ?? null;

export default bottomSheetSlice.reducer;
